import { render, staticRenderFns } from "./proceedingsDetail.vue?vue&type=template&id=6f132846"
import script from "./proceedingsDetail.vue?vue&type=script&lang=js"
export * from "./proceedingsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f132846')) {
      api.createRecord('6f132846', component.options)
    } else {
      api.reload('6f132846', component.options)
    }
    module.hot.accept("./proceedingsDetail.vue?vue&type=template&id=6f132846", function () {
      api.rerender('6f132846', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/osh/proceedingsDetail.vue"
export default component.exports